import api from "@/api";

export default {
  get: () => {
    return api.get("/users/me").then((response) => response);
  },
  activateUser: (encryptCode, newPassword, confirmNewPassword) => {
    return api
      .post("/user-activate", { encryptCode, newPassword, confirmNewPassword })
      .then((response) => response);
  },
  checkUserActivationRecord: (encryptCode) => {
    return api
      .post("/user-activate/check-record", { encryptCode })
      .then((response) => response);
  },  
  userSubscribe: (encryptCode, userId, services) => {
    return api
      .post("/user-activate/subscribe", { encryptCode, userId, services })
      .then((response) => response);
  },

  associateAccount: (cityId, password) => {
    return api
      .post("/users/associate", { cityId, password })
      .then((response) => response);
  },

  getAssociateAccountList: () => {
    return api
      .get("/users/associate/get")
      .then((response) => response);
  },

  unAssociateAccount: (id) => {
    return api
      .post("/users/associate/remove", { id })
      .then((response) => response);
  },

  activateBuyer: (encryptCode, newPassword, confirmNewPassword) => {
    return api
      .post("/user-activate/buyer", { encryptCode, newPassword, confirmNewPassword})
      .then((response) => response);
  },

};
